import { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface SettingsSectionProps {
  title?: string;
  // Applies destructive-token styling for grouping irreversible actions.
  danger?: boolean;
  children: ReactNode;
}

/**
 * Titled card that groups related settings action rows on an entity's Settings
 * page. The `danger` variant gives the irreversible actions (delete / leave) a
 * destructive-accented frame and heading.
 */
export const SettingsSection = ({ title, danger = false, children }: SettingsSectionProps) => (
  <section
    className={cn("rounded-lg border bg-card", danger ? "border-destructive/40" : "border-border")}
  >
    {title && (
      <h2
        className={cn(
          "border-b px-4 py-3 text-sm font-semibold",
          danger ? "border-destructive/40 text-destructive" : "border-border text-foreground"
        )}
      >
        {title}
      </h2>
    )}
    <div className="divide-y divide-border">{children}</div>
  </section>
);
